var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9164 51.682L32.3534 52.2518L29.08 5.58616L27.6686 5.01534L30.9164 51.682Z",
    fill: "#FFB700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0795 5.5857L32.3529 52.2513L33.4532 51.5407L30.1809 4.90049L29.1072 5.60898L29.0795 5.5857Z",
    fill: "#F7900B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6503 4.57764e-05L20.5563 0.731854L29.0993 5.61085L30.1795 4.9013L21.6503 4.57764e-05Z",
    fill: "#FFE057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1004 5.61117L20.5574 0.732174L20.5371 2.03584L29.0578 6.90214L29.0653 5.62071L29.1004 5.61117Z",
    fill: "#FFB700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20911 28.5991V30.265L10.7569 30.8167L30.0118 18.1389L28.464 17.5861L9.20911 28.5991Z",
    fill: "#6D6D6D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7566 29.1519V30.8178L30.0115 19.8048V18.14L10.7566 29.1519Z",
    fill: "#F7900B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7569 29.1509L9.20911 28.5991L28.464 17.5861L30.0118 18.1389L10.7569 29.1509Z",
    fill: "#FFE057"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8781 63.2647L12.3162 63.8334L9.04278 17.1678L7.63135 16.597L10.8781 63.2647Z",
    fill: "#FFB700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04224 17.1676L12.3157 63.8332L13.415 63.1237L10.1437 16.4835L9.06993 17.1909L9.04224 17.1676Z",
    fill: "#F7900B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61315 11.5809L0.519165 12.3127L9.06118 17.1917L10.1424 16.4822L1.61315 11.5809Z",
    fill: "#FFE057"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06227 17.192L0.520252 12.313L0.5 13.6157L9.01965 18.482L9.02709 17.2016L9.06227 17.192Z",
    fill: "#FFB700"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9178 60.3891C40.9178 57.5095 38.5562 53.8092 35.6599 52.1518C34.127 51.2739 32.7475 51.1468 31.7846 51.6424L31.7888 51.6329L31.6621 51.706C31.6376 51.7208 31.6109 51.7335 31.5864 51.7494L28.8936 53.3019L31.9401 53.4587C31.9401 53.465 31.939 53.4714 31.939 53.4778C31.939 56.3308 34.2601 59.9887 37.1213 61.6673L36.9807 63.3417L36.8209 64.6898L39.6512 63.0547C39.6789 63.0377 39.7077 63.0239 39.7354 63.0059L39.7439 63.0007L39.7428 62.9996C40.4757 62.522 40.9178 61.6313 40.9178 60.3891Z",
    fill: "#010007"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7624 53.8237C29.8661 52.1663 27.5045 53.1629 27.5045 56.0413C27.5045 58.9198 29.8661 62.6201 32.7624 64.2775C35.6577 65.9349 38.0204 64.9384 38.0204 62.0599C38.0204 59.1814 35.6588 55.4811 32.7624 53.8237Z",
    fill: "#2E2D30"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7618 54.3309C30.1467 52.8334 28.0131 53.7336 28.0131 56.3336C28.0131 58.9335 30.1456 62.2748 32.7618 63.7723C35.3769 65.2687 37.5095 64.3696 37.5095 61.7696C37.5106 59.1686 35.3769 55.8273 32.7618 54.3309Z",
    fill: "#1B1B1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7616 55.5806C30.8389 54.4803 29.2709 55.1411 29.2709 57.0537C29.2709 58.9653 30.8389 61.4223 32.7616 62.5226C34.6843 63.623 36.2523 62.9621 36.2523 61.0505C36.2523 59.1379 34.6843 56.6809 32.7616 55.5806Z",
    fill: "#3B3B3B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9076 55.8345C31.2097 54.8634 29.8259 55.4469 29.8259 57.135C29.8259 58.8221 31.2107 60.991 32.9076 61.9632C34.6045 62.9343 35.9893 62.3508 35.9893 60.6638C35.9893 58.9756 34.6056 56.8067 32.9076 55.8345Z",
    fill: "#CECECE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9075 55.9297C31.2628 54.9882 29.9216 55.5537 29.9216 57.1889C29.9216 58.823 31.2628 60.9241 32.9075 61.8656C34.5511 62.8071 35.8922 62.2405 35.8922 60.6064C35.8933 58.9723 34.5522 56.8711 32.9075 55.9297Z",
    fill: "#A19E9C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.908 56.1148C31.3656 55.2315 30.1075 55.7621 30.1075 57.2956C30.1075 58.8291 31.3656 60.8 32.908 61.6821C34.4504 62.5643 35.7085 62.0337 35.7085 60.5013C35.7085 58.9678 34.4504 56.998 32.908 56.1148Z",
    fill: "#CECECE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5077 59.9404C35.2957 58.5997 34.2177 57.0302 32.9075 56.2835C32.8883 56.2645 32.8499 56.2454 32.8308 56.2454C31.4247 55.4607 30.2689 55.9584 30.2689 57.3945C30.2689 58.8305 31.4631 60.6881 32.9075 61.5311C34.3711 62.354 35.546 61.8562 35.546 60.4011C35.546 60.2465 35.5268 60.094 35.5077 59.9404Z",
    fill: "#7C7774"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9054 56.282C32.8862 56.263 32.8478 56.2439 32.8286 56.2439C32.2896 56.2439 31.9424 56.6082 31.9424 57.2775C31.9424 58.273 32.7701 59.5757 33.7724 60.1497C34.581 60.6093 35.2552 60.4938 35.5055 59.9389C35.2936 58.5992 34.2156 57.0297 32.9054 56.282Z",
    fill: "#CECECE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5887 58.0225L34.4675 58.6177L12.6156 71.1896L11.7463 70.6092L33.5887 58.0225Z",
    fill: "#B66828"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6161 71.1892L34.468 58.6173L34.484 59.5133L12.647 72.0756L12.6406 71.1955L12.6161 71.1892Z",
    fill: "#824A1D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8556 73.7088C17.8556 70.8292 15.494 67.1289 12.5977 65.4715C11.0648 64.5936 9.68538 64.4665 8.72242 64.9621L8.72671 64.9526L8.59993 65.0257C8.57543 65.0405 8.54881 65.0532 8.52431 65.0691L5.83142 66.6217L8.87797 66.7784C8.87797 66.7847 8.8769 66.7911 8.8769 66.7975C8.8769 69.6505 11.198 73.3084 14.0592 74.987L13.9186 76.6614L13.7588 78.0095L16.5891 76.3744C16.6168 76.3574 16.6455 76.3436 16.6732 76.3256L16.6828 76.3204L16.6818 76.3193C17.4146 75.8417 17.8556 74.951 17.8556 73.7088Z",
    fill: "#010007"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70028 67.1434C6.80395 65.486 4.44238 66.4826 4.44238 69.361C4.44238 72.2395 6.80395 75.9398 9.70028 77.5972C12.5956 79.2546 14.9582 78.2581 14.9582 75.3796C14.9571 72.5011 12.5956 68.8008 9.70028 67.1434Z",
    fill: "#2E2D30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69966 67.6506C7.08454 66.1531 4.95093 67.0533 4.95093 69.6533C4.95093 72.2532 7.08347 75.5945 9.69966 77.092C12.3148 78.5884 14.4473 77.6893 14.4473 75.0893C14.4473 72.4883 12.3148 69.1471 9.69966 67.6506Z",
    fill: "#1B1B1F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70052 68.9003C7.77779 67.8 6.20874 68.4608 6.20874 70.3734C6.20874 72.285 7.77673 74.742 9.70052 75.8423C11.6232 76.9427 13.1913 76.2808 13.1913 74.3703C13.1913 72.4576 11.6232 70.0006 9.70052 68.9003Z",
    fill: "#3B3B3B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84548 69.1542C8.14752 68.1831 6.76379 68.7666 6.76379 70.4547C6.76379 72.1418 8.14859 74.3107 9.84548 75.2829C11.5424 76.254 12.9272 75.6705 12.9272 73.9824C12.9272 72.2953 11.5424 70.1264 9.84548 69.1542Z",
    fill: "#CECECE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84532 69.2505C8.20062 68.309 6.8595 68.8756 6.8595 70.5097C6.8595 72.1449 8.20062 74.2449 9.84532 75.1864C11.49 76.1279 12.8311 75.5613 12.8311 73.9272C12.83 72.2931 11.489 70.192 9.84532 69.2505Z",
    fill: "#A19E9C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84587 69.4345C8.30343 68.5512 7.04541 69.0818 7.04541 70.6153C7.04541 72.1488 8.30343 74.1197 9.84587 75.0018C11.3883 75.884 12.6463 75.3535 12.6463 73.821C12.6453 72.2875 11.3872 70.3177 9.84587 69.4345Z",
    fill: "#CECECE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4429 73.2601C12.2309 71.9194 11.1529 70.3499 9.84264 69.6033C9.82347 69.5842 9.78513 69.5651 9.76596 69.5651C8.35986 68.7804 7.2041 69.2781 7.2041 70.7142C7.2041 72.1503 8.3982 74.0078 9.84264 74.8508C11.3063 75.6737 12.4812 75.1759 12.4812 73.7208C12.4823 73.5662 12.462 73.4137 12.4429 73.2601Z",
    fill: "#7C7774"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8432 69.6017C9.82403 69.5827 9.78569 69.5636 9.76651 69.5636C9.22751 69.5636 8.88025 69.9279 8.88025 70.5972C8.88025 71.5927 9.70794 72.8954 10.7103 73.4694C11.5188 73.929 12.1931 73.8135 12.4434 73.2586C12.2314 71.9189 11.1534 70.3494 9.8432 69.6017Z",
    fill: "#CECECE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20886 48.808L9.22164 65.9464L10.7705 66.4982L34.5931 35.7373L33.0442 35.1844L9.20886 48.808Z",
    fill: "#6D6D6D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7563 49.3615L10.7702 66.4989L34.6056 52.8754L34.5928 35.738L10.7563 49.3615Z",
    fill: "#808080"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7566 49.3608L9.20886 48.808L33.0442 35.1844L34.5931 35.7373L10.7566 49.3608Z",
    fill: "#C7C7C7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7146 71.5777L10.7706 66.4985V64.7204L49.4999 56.0892V57.8663L25.7146 71.5777Z",
    fill: "#6D6D6D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7146 69.7996L10.7706 64.7205L34.5559 51.0101L49.4999 56.0893L25.7146 69.7996Z",
    fill: "#C7C7C7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7131 69.7996V71.5777L49.4984 57.8663V56.0892L25.7131 69.7996Z",
    fill: "#3D3D3D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7366 66.5062L44.21 57.6473V49.1813L28.7366 58.0402V66.5062Z",
    fill: "#AB7835"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7373 58.0399L44.2107 49.181L31.4899 45.0073L16.0165 53.8662L28.7373 58.0399Z",
    fill: "#EBC26C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0165 53.8666L28.7373 58.0403V66.5063L16.0165 62.3771V53.8666Z",
    fill: "#C9974B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7306 57.6742L17.736 59.0743L18.3858 59.2808L18.3804 57.8807L18.7053 57.9845L18.0523 56.7677L17.4058 57.5704L17.7306 57.6742Z",
    fill: "#965A2C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3271 55.6067L36.4746 46.6409L38.3004 47.2297L23.2914 56.2241V57.2747L21.3357 56.5821L21.3271 55.6067Z",
    fill: "#F2E5DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.c5860701e820852053d566081a81c662.svg";
export { ForwardRef as ReactComponent };